import { Job, JobType } from 'types/Job'

// by default every job will be re-fetched for metadata unless included in this denylist
export const isJobMetadataRequired = (job: Job): boolean => {
  const denyList: JobType[] = ['addtemplate', 'deletetemplate', 'updatetemplate']

  return !denyList.includes(job.type!)
}
